import { allowBodyScroll, preventBodyScroll } from '../../../utils/body-scroll';
import { globalActions } from '../../global-actions';

export const getActionTypes = (actionPrefix) => ({
  // START
  QUERY_START: `${actionPrefix}_QUERY_START`,
  MUTATION_START: `${actionPrefix}_MUTATION_START`,
  // SUCCESS
  QUERY_SUCCESS: `${actionPrefix}_QUERY_SUCCESS`,
  MUTATION_SUCCESS: `${actionPrefix}_MUTATION_SUCCESS`,
  // FAILURE
  QUERY_FAILURE_GENERIC: `${actionPrefix}_QUERY_FAILURE_GENERIC`,
  QUERY_FAILURE_401: `${actionPrefix}_QUERY_FAILURE_401`,
  MUTATION_FAILURE_GENERIC: `${actionPrefix}_MUTATION_FAILURE_GENERIC`,
  MUTATION_FAILURE_401: `${actionPrefix}_MUTATION_FAILURE_401`,
  // RESET
  RESET_STATUS_NOTIFICATION: `${actionPrefix}_RESET_STATUS_NOTIFICATION`,
  RESET_LOADER: `${actionPrefix}_RESET_LOADER`,
  // USER INTERACTION
  SELECT_OPTIONS: `${actionPrefix}_SELECT_OPTIONS`,
  SHOW_UNSUBSCRIBE_MODAL: `${actionPrefix}_SHOW_UNSUBSCRIBE_MODAL`,
  SHOW_NEWSLETTERS_FULL_SCREEN: `${actionPrefix}_SHOW_NEWSLETTERS_FULL_SCREEN`,
});

export const getActions = (actionPrefix) => ({
  setQueryStart: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_START,
    });
  },
  setMutationStart: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_START,
    });
  },
  setQuerySuccess: (data) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_SUCCESS,
      payload: { data },
    });
  },
  setMutationSuccess: (data) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_SUCCESS,
      payload: { data },
    });
  },
  setQueryFailureGeneric: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_FAILURE_GENERIC,
      payload: { error },
    });
  },
  setQueryFailure401: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_FAILURE_401,
      payload: { error },
    });
  },
  setMutationFailureGeneric: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_FAILURE_GENERIC,
      payload: { error },
    });
  },
  setMutationFailure401: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).MUTATION_FAILURE_401,
      payload: { error },
    });
  },
  resetStatusNotification: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).RESET_STATUS_NOTIFICATION,
    });
  },
  resetLoader: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).RESET_LOADER,
    });
  },
  selectNewsletters: (options) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SELECT_OPTIONS,
      payload: { options },
    });
  },
  showUnsubscribeModal: (showUnsubscribeModal) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SHOW_UNSUBSCRIBE_MODAL,
      payload: { showUnsubscribeModal },
    });
  },
  showNewslettersFullScreen: (showNewslettersFullScreen) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SHOW_NEWSLETTERS_FULL_SCREEN,
      payload: { showNewslettersFullScreen },
    });
  },
});
